<template>
  <!-- <keep-alive> -->
    <router-view :key="$route.fullPath"></router-view>
  <!-- </keep-alive> -->
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  @font-face {
    font-family: "Inter";
    src: local("Inter"),
     url(../public/font/Inter-VariableFont_slnt\,wght.ttf) format("truetype");
  }
</style>